module.exports = __webpack_public_path__ + "static/media/OurLadysAcademy.83c20767.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/OurLadysAcademy.jpg
// module id = 748
// module chunks = 0